import {asyncRouterMap, constantRouterMap} from 'src/router';
import {queryPermission} from 'api/login';

/**
 * 通过meta.role判断是否与当前用户权限匹配
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
    if (route.meta && route.meta.role) {
        return roles.some(role => route.meta.role.indexOf(role) >= 0)
    } else {
        return true
    }
}
/**
 * 根据权限匹配路由
 * @param {array} permission 权限列表（菜单列表）
 * @param {array} asyncRouter 异步路由对象
 */
function routerMatch(permission, asyncRouter) {
        // 创建路由
        const role = permission[0].role;
        function createRouter(permission) {
            // 根据路径匹配到的router对象添加到routers中即可
            permission.forEach((item) => {
                if (item.children && item.children.length) {
                    createRouter(item.children);
                }
                let path = item.path;
                // 循环异步路由，将符合权限列表的路由加入到routers中
                asyncRouter.find((s) => {
                    if (s.path === '/') {
                        s.children.find((y) => {
                            if (y.path === path) {
                                y.meta.role = role;
                                y.meta.permission = item.permission?item.permission:[];
                                // routers.push(s);
                            }
                        })
                    }
                    if (s.path === path) {
                        s.meta.role = role;
                        s.meta.permission = item.permission;
                        // routers.push(s);
                    }
                })
            })
        }
        createRouter(permission);
        return asyncRouter;
}

/**
 * 递归过滤异步路由表，返回符合用户角色权限的路由表
 * @param asyncRouterMap
 * @param roles
 */
function filterAsyncRouter(asyncRouterMap, roles) {
    const accessedRouters = asyncRouterMap.filter(route => {
        if (hasPermission(roles, route)) {

            if (route.children && route.children.length) {
                route.children = filterAsyncRouter(route.children, roles)
            }
            return true
        }
        return false
    })
    return accessedRouters
}

function getNowRouter(asyncRouterMap, to) {
    return asyncRouterMap.some(route => {
        if (to.path.indexOf(route.path) !== -1) {
            return true;
        }
        else if (route.children && route.children.length) { //如果有孩子就遍历孩子
            return getNowRouter(route.children, to)
        }
    })
}
const permission = {
    state: {
        routers: constantRouterMap,
        addRouters: [],
        siderbar_routers: [],
    },
    mutations: {
        SET_ROUTERS: (state, routers) => {
            state.addRouters = routers;
            state.routers = constantRouterMap.concat(routers);
            // state.routers.forEach(function(e){
            //     console.log('okkkk:'+JSON.stringify(e))
            // })
            // state.routers.forEach(function(e){
            //     if(e.name==="首页"){
            //     state.siderbar_routers=e;

            //     }

            // })

        },
        SET_NOW_ROUTERS: (state, to) => {
            // 递归访问 accessedRouters，找到包含to 的那个路由对象，设置给siderbar_routers
            // console.log(state.addRouters)
            state.addRouters.forEach(e => {
                if (e.children && e.children.length) {
                    if (getNowRouter(e.children, to) === true)
                        state.siderbar_routers = e;
                }
            })
        }

    },
    actions: {
        GenerateRoutes({commit}, data) {
                return new Promise(resolve => {
                    const roles = data.role;
                    const account = data.account;
                    let accessedRouters;
                    queryPermission(account).then(response => {
                        if (roles.indexOf('admin') >= 0) {
                            accessedRouters = routerMatch(response.data,asyncRouterMap);
                        } else {
                            // 角色包含otaAgent字母，指定首页otaSimList
                            if (roles[0] && roles[0].indexOf('otaAgent') >= 0) {
                                asyncRouterMap[0]['redirect'] = '/otaSimList';
                            }
                            accessedRouters = filterAsyncRouter(routerMatch(response.data,asyncRouterMap), roles);
                        }
                        commit('SET_ROUTERS', accessedRouters);
                        resolve();
                    }).catch(error => {

                    });
                })
        },
        getNowRoutes({commit}, data) {
            return new Promise(resolve => {
                commit('SET_NOW_ROUTERS', data);
                resolve();
            })
        },
    },
};

export default permission;



// WEBPACK FOOTER //
// ./src/store/modules/permission.js